"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterObjects = exports.DateFilter = exports.DateFilterOption = exports.FilterEqual = exports.Filter = exports.FilterType = void 0;
const lodash_1 = require("lodash");
const obejct_diff_1 = require("../utils/obejct-diff");
const moment = require("moment");
var FilterType;
(function (FilterType) {
    FilterType[FilterType["EQUALITY"] = 0] = "EQUALITY";
    FilterType[FilterType["DATE"] = 1] = "DATE";
})(FilterType || (exports.FilterType = FilterType = {}));
class Filter {
    // private sortOrder = FilterSort.UNSORTED
    constructor(filterName, filterField, filterValue, filterCheckExtraFiled
    // sort?: FilterSort
    ) {
        this.filterName = filterName;
        this.filterField = filterField;
        this.filterValue = filterValue;
        this.filterCheckExtraFiled = filterCheckExtraFiled;
        // if (sort) this.sortOrder = sort
    }
}
exports.Filter = Filter;
class FilterEqual extends Filter {
    constructor(filterName, filterField, filterValue, filterCheckExtraFiled) {
        super(filterName, filterField, filterValue);
    }
    filterFn(record) {
        // if (!Object.keys(record).includes(this.filterField)) return false
        // return record[`${this.filterField}`] == this.filterValue
        if (!Object.keys(record).includes(this.filterField))
            return false;
        else {
            if ((0, lodash_1.isArray)(record[`${this.filterField}`])) {
                if (record[`${this.filterField}`].length == 0)
                    return false;
                else {
                    return record[`${this.filterField}`].includes(this.filterValue);
                }
            }
            else
                return record[`${this.filterField}`] == this.filterValue;
        }
    }
    filterExtraFieldFn(record) {
        var _a;
        let included = false;
        (_a = this.filterCheckExtraFiled) === null || _a === void 0 ? void 0 : _a.forEach((filter) => {
            if (!Object.keys(record).includes(filter.key))
                return included = false;
            else {
                if (filter.type == 'array') {
                    if (!record[`${filter.key}`])
                        return included = false;
                    else {
                        if (record[`${filter.key}`].includes(filter.value))
                            return included = record[`${filter.key}`].includes(filter.value);
                    }
                }
                else
                    return included = record[`${filter.key}`] == filter.value;
            }
        });
        return included;
    }
}
exports.FilterEqual = FilterEqual;
var DateFilterOption;
(function (DateFilterOption) {
    DateFilterOption[DateFilterOption["BEFORE"] = 0] = "BEFORE";
    DateFilterOption[DateFilterOption["AFTER"] = 1] = "AFTER";
    DateFilterOption[DateFilterOption["BETWEEN"] = 2] = "BETWEEN";
    DateFilterOption[DateFilterOption["NOTIN"] = 3] = "NOTIN";
})(DateFilterOption || (exports.DateFilterOption = DateFilterOption = {}));
class DateFilter extends Filter {
    constructor(filterName, filterField, filterOption, filterValue) {
        super(filterName, filterField, filterValue);
        this.filterValue = filterValue;
        this.dateFilterOption = DateFilterOption.BEFORE;
        if (filterOption)
            this.dateFilterOption = filterOption;
    }
    filterFn(record) {
        if (!Object.keys(record).includes(this.filterField))
            return false;
        if (!(0, obejct_diff_1.isDate)(record[`${this.filterField}`]))
            return false;
        switch (this.dateFilterOption) {
            case (DateFilterOption.AFTER): {
                return record[`${this.filterField}`] >= this.filterValue.baseValue;
            }
            case (DateFilterOption.BEFORE): {
                return record[`${this.filterField}`] <= this.filterValue.baseValue;
            }
            case (DateFilterOption.BETWEEN): {
                if (!this.filterValue.startDate || !this.filterValue.endDate)
                    return false;
                const start = moment(this.filterValue.startDate);
                const end = moment(this.filterValue.endDate);
                return moment(record[`${this.filterField}`]).isBetween(start, end);
            }
            case (DateFilterOption.NOTIN): {
                if (!this.filterValue.startDate || !this.filterValue.endDate)
                    return false;
                const start = moment(this.filterValue.startDate);
                const end = moment(this.filterValue.endDate);
                // const dateBetween = moment(this.filterValue.baseValue)
                return !moment(record[`${this.filterField}`]).isBetween(start, end);
            }
        }
    }
    filterExtraFieldFn(record) {
        let included = false;
        return included;
    }
}
exports.DateFilter = DateFilter;
/**
 *
 * @param records
 *  any Objects
 * @param filter
 *  List of filters, individual lists represent
 *  OR filters list combined represent AND
 * @returns
 *  records or empty array after applying filters
 */
const filterObjects = (records, filter) => {
    const filtered = new Set();
    records.forEach((record) => {
        let and = true;
        filter.forEach((orFilter, index) => {
            let or = false;
            orFilter.forEach((f, index) => {
                const filterFn = f.filterFn(record);
                if (filterFn)
                    or = true;
                if (f.filterCheckExtraFiled) {
                    if (f.filterExtraFieldFn(record) || filterFn)
                        or = true;
                }
            });
            if (!or) {
                and = false;
                return;
            }
        });
        if (and)
            filtered.add(record);
    });
    return [...filtered.values()];
};
exports.filterObjects = filterObjects;
